import React, { useState, useEffect } from 'react'
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { Autocomplete, Stack, TextField } from '@mui/material'
import ReactTooltip from 'react-tooltip'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import NumberFormat from 'react-number-format'
import { useMonitoreo } from '../../../context/MonitoreoContext'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import { useAuthentication } from '../../../context/authenticationContext'
import {
  getMIPYMEForInform,
  getProjectsMIPYMEForInform,
  getValidationsFinalTerm,
} from '../../../services/MonitoreoYEvaluacion/get'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { insertReportAnswers } from '../../../services/MonitoreoYEvaluacion/create'
import swal from 'sweetalert'
import { useFormMonitoringAndEvaluation } from '../../../context/MonitoringAndEvaluationContext'
import Moment from 'moment'
import ROUTES from '../../../routers/routes'

export const MonitoreoSeccion1 = (props) => {
  const [, dispatch] = useMonitoreo()
  const { userIDB2C } = useAuthentication()
  const { goToStep, edit } = props
  const history = useHistory()
  const [mipyme, setMipyme] = useState([])
  const [loading, setLoading] = useState(false)
  const { monitoringAndEvaluationForm, setMonitoringAndEvaluationForm } =
    useFormMonitoringAndEvaluation()

  const GeneralDataSchema = Yup.object().shape({
    IdMiPyme: Yup.number().required('Este campo es obligatorio'),
  })

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      SubprojectName: monitoringAndEvaluationForm.SubprojectName || '',
      ImplementationDateStart:
        Moment(monitoringAndEvaluationForm.ImplementationDateStart)
          .format('YYYY-MM-DD')
          .toString() || '',
      ImplementationDateEnd:
        Moment(monitoringAndEvaluationForm.ImplementationDateEnd)
          .format('YYYY-MM-DD')
          .toString() || '',
      IdReportAnswer: monitoringAndEvaluationForm.IdReportAnswer || 0,
      IdQuestionnaireAnswer:
        monitoringAndEvaluationForm.IdQuestionnaireAnswer || '',
      IdFormAction: 65,
      IdUserAzureB2C: userIDB2C,
      Draft: true,
      IdReportType: monitoringAndEvaluationForm.IdReportType || '',
      Presentation_Date: valueDate.someDate,
      IdMiPyme: monitoringAndEvaluationForm.IdMiPyme || '',
      CurrentDateimplementation:
        Moment(monitoringAndEvaluationForm.CurrentDateimplementation)
          .format('YYYY-MM-DD')
          .toString() || '',
      ReportingPeriod:
        Moment(monitoringAndEvaluationForm.ReportingPeriod)
          .format('YYYY-MM-DD')
          .toString() || '',
      RequiredAmountDollarsCurrency:
        monitoringAndEvaluationForm.RequiredAmountDollarsCurrency || '',
      TotalSubProjectBudgetDollar:
        monitoringAndEvaluationForm.TotalSubProjectBudgetDollar || '',
      TypeReporte: monitoringAndEvaluationForm.TypeReporte || '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      let object = values
      object = {
        ...values,
        ...monitoringAndEvaluationForm,
      }

      const response = await insertReportAnswers(object)

      if (response.Success) {
        if (!response.Data.Message) {
          formik.setFieldValue('IdReportAnswer', response.Data.IdReportAnswer)
          setMonitoringAndEvaluationForm({
            ...monitoringAndEvaluationForm,
            IdReportAnswer: response.Data.IdReportAnswer,
          })

          if (borrador) {
            swal({
              title: 'Formulario Guardado',
              icon: 'success',
              button: 'Entendido',
            })

            if (exit) {
              if (edit) {
                history.push(ROUTES.IFIBORRADOR.pathname)
                dispatch({ type: 'SET_STATE', payload: 1 })
              } else {
                history.push('/')
                dispatch({ type: 'SET_STATE', payload: 1 })
              }
            }
          } else {
            saveValuesToContext(values)
            next()
          }
        } else {
          swal({
            title: `No se puede puede guardar el formulario`,
            text: `${response.Data.MessageInfo[0].Message}`,
            icon: `error`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Entendido',
                value: 'catch',
              },
            },
          })
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  const saveValuesToContext = (values) => {
    setMonitoringAndEvaluationForm((previous) => {
      const valuesSave = {
        IdQuestionnaireAnswer: values.IdQuestionnaireAnswer,
        IdFormAction: values.IdFormAction,
        IdReportType: values.IdReportType,
        Presentation_Date: values.Presentation_Date,
        // IdReportAnswer: formik.values.IdReportAnswer,
        Indicator_Description: values.Indicator_Description,
        Draft: values.Draft,
        IdUserAzureB2C: values.IdUserAzureB2C,
        SubprojectName: values.SubprojectName,
        IdMiPyme: values.IdMiPyme,
      }
      return {
        ...previous,
        ...valuesSave,
      }
    })
  }
  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          if (formik.values.TypeReporte === 'Informe Final de Termino') {
            validationFinalTerm()
          } else formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR', error))
  }

  const validationFinalTerm = async () => {
    try {
      const response = await getValidationsFinalTerm(
        formik.values.IdQuestionnaireAnswer,
      )
      if (response.Success) {
        if (!response.Data.Message) {
          formik.submitForm()
        } else {
          swal({
            title: `No se puede puede guardar el formulario`,
            text: `${response.Data.MessageInfo[0].Message}`,
            icon: `error`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Entendido',
                value: 'catch',
              },
            },
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  useEffect(() => {
    getMIPME()
  }, [])

  const getMIPME = async () => {
    try {
      const response = await getMIPYMEForInform(userIDB2C)
      if (response.Success) {
        setMipyme(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getMIPMEProjects = async (idMIPYME) => {
    try {
      setLoading(true)
      const response = await getProjectsMIPYMEForInform(idMIPYME)
      if (response.Success) {
        formik.setValues({
          ...formik.values,
          IdMiPyme: response.Data.IdMiPyme,
          SubprojectName: response.Data.SubprojectName,
          ImplementationDateStart: Moment(response.Data.ImplementationDateStart)
            .format('YYYY-MM-DD')
            .toString(),
          ImplementationDateEnd: Moment(response.Data.ImplementationDateEnd)
            .format('YYYY-MM-DD')
            .toString(),
          CurrentDateimplementation: Moment(
            response.Data.CurrentDateimplementation,
          )
            .format('YYYY-MM-DD')
            .toString(),
          ReportingPeriod: Moment(response.Data.ReportingPeriod)
            .format('YYYY-MM-DD')
            .toString(),

          TotalSubProjectBudgetDollar:
            response.Data.TotalSubProjectBudgetDollar,
          RequiredAmountDollarsCurrency:
            response.Data.RequiredAmountDollarsCurrency,
          TypeReporte: response.Data.TypeReporte,
          IdQuestionnaireAnswer: response.Data.IdQuestionnaireAnswer,
          Indicator_Description: response.Data.Indicator_Description,
          IdProject: response.Data.IdProject,
          IdReportType:
            response.Data.TypeReporte === 'Informe Final de Termino' ? 8 : 7,
        })
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        saveForm(formik.values, true, true)
      } else if (result.isDenied) {
        if (edit) {
          history.push(ROUTES.IFIBORRADOR.pathname)
          dispatch({ type: 'SET_STATE', payload: 1 })
        } else {
          history.push('/')
          dispatch({ type: 'SET_STATE', payload: 1 })
        }
      }
    })
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        {formik.values.IdMiPyme !== '' ? (
          <Grid item>
            <div
              onClick={() => saveForm(formik.values, true)}
              data-tip
              data-for="savePop"
              style={{
                backgroundColor: '#5cb85c',
                color: '#fff',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                padding: '5px',
                cursor: 'pointer',
              }}
            >
              <SaveIcon />
            </div>
            <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
              <span>Guardar Borrador</span>
            </ReactTooltip>
          </Grid>
        ) : (
          <Grid item>
            <div
              data-tip
              data-for="savePop"
              style={{
                backgroundColor: 'grey',
                color: '#fff',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                padding: '5px',
                cursor: 'pointer',
              }}
            >
              <SaveIcon />
            </div>
            <ReactTooltip id="savePop" effect="solid">
              <span>Guardar Borrador</span>
            </ReactTooltip>
          </Grid>
        )}
      </Grid>

      <form id="transfers-form">
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">Información General</label>
              </div>
              <label className="formDescription">
                Informe de seguimiento de medio término al progreso de
                subproyetos
              </label>
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1. Nombre de la MIPYME
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.2 Título del subproyecto financiado
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                {!edit ? (
                  <Autocomplete
                    getOptionLabel={(option) => `${option.NameMiPyme}`}
                    disablePortal
                    id="combo-box-demo"
                    options={mipyme}
                    sx={{ width: '100%' }}
                    // value={formik.values.IdMiPyme}
                    renderInput={(params) => <TextField {...params} />}
                    onChange={(e, value) => {
                      console.log('value' + value.IdMiPyme)
                      formik.setValues({
                        ...formik.values,
                        IdMiPyme: value.IdMiPyme,
                      })

                      formik.setFieldValue('IdMiPyme', Number(value.IdMiPyme))
                      getMIPMEProjects(value.IdMiPyme)
                      console.log('formik.', formik.values.IdMiPyme)
                    }}
                  />
                ) : (
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    value={monitoringAndEvaluationForm.MiPymeName}
                    disabled
                  />
                )}

                {formik.errors.IdMiPyme ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.IdMiPyme}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: '100%' }}
                  value={formik.values.SubprojectName}
                  disabled
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.3. Período estimado de implementación de la inversión
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    // defaultValue={formik.ImplementationDateStart}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={formik.values.ImplementationDateStart}
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    value={formik.values.ImplementationDateEnd}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.4. Fecha en curso de la implementación
              </label>
              <a
                data-tip="- Fecha media del período de implementación <br/>  de la inversión"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
              >
                <HelpOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.5. Fecha de presentación del informe
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    disabled
                    value={formik.values.CurrentDateimplementation}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={formik.values.Presentation_Date}
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.6. Período del reporte
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Inicio proyecto"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={formik.values.ReportingPeriod}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Fecha presentación"
                    type="date"
                    variant="outlined"
                    value={formik.values.Presentation_Date}
                    disabled
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.7. Presupuesto total del subproyecto
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.8. Monto total del préstamo otorgado
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="RequiredAmount"
                  name="RequiredAmount"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.RequiredAmountDollarsCurrency}
                  autoComplete="off"
                  disabled
                  prefix="$"
                  allowNegative={false}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 13 }}
                  fixedDecimalScale
                  decimalScale={2}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="RequiredAmount"
                  name="RequiredAmount"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.TotalSubProjectBudgetDollar}
                  autoComplete="off"
                  disabled
                  prefix="$"
                  allowNegative={false}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 13 }}
                  fixedDecimalScale
                  decimalScale={2}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">1.9. Tipo de informe</label>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                {!loading && (
                  <RadioGroup
                    id="TypeBeneficiary"
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    row
                    value={formik.values.TypeReporte}
                  >
                    <FormControlLabel
                      value="Informe Medio Termino"
                      control={<Radio />}
                      label="Medio término"
                      disabled
                    />
                    <FormControlLabel
                      value="Informe Final de Termino"
                      control={<Radio />}
                      label="Final de término"
                      disabled
                    />
                  </RadioGroup>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <Button
                type="button"
                onClick={() => validateFormStatus()}
                className="button__wizard button__next"
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
